












































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { IconCardGrid } from "@/components.generic/icon-card-grid";
import { useTags } from "@/hooks/useTags";
import { useFavourites } from "@/hooks/useFavourites";
import { Tag } from "@/psychlab/types/tags";
import * as AppModal from "@/AppModal";

export default defineComponent({

	emits:[],
	props:{
	},
	components:{
		IconCardGrid,
	},
	setup(props, context){

		const {
			sortedTags,
			editTag,
			createTag,
			deleteTag,
		} = useTags();

		const {
			addFavourite,
			removeFavourite,
			isFavourite
		} = useFavourites();

		const getTagRoute = (tag:Tag) => {

			const query:any = { ...context.root.$route.query };
			return {
				name:'view-tag', 
				params:{
					tagId:tag._id
				},
				query
			}
		};
		
		const onAddTag = () => {
			AppModal.editText({
				title:"New Tag",
				value:"New Tag",
				validator(v){
					return v.length > 1;
				},
			},  (v:string) => {
				createTag(v);
			});
		};

		const rename = (tag:Tag) => {
			AppModal.editText({
				title:"Rename",
				value:tag.name,
				validator(v){
					return v !== tag.name;
				}
			}, (v:string) => editTag(tag._id, { name:v }));
		};

		const setColor = (tag:Tag) => {
			// if(!editColorModal.value){ return; }
			AppModal.editColor({
				title:"Set Tag Color",
				value:tag.color
			}, (v:string) => {
				editTag(tag._id, { color:v });
			});
		};

		const delTag = (tag:Tag) => {
			AppModal.confirm({
				title:"Delete",
				variant:"danger",
				okText:"I Understand",
				description:"Are you sure? This is irreversible."
			}, () => {
				deleteTag(tag._id);
			});
		};

		const openContext = (event:any, tag:Tag) => {

			const options:any[] = [];

			if(isFavourite(tag._id)){
				options.push({
					name:"Remove From Favourites",
					icon:"mdi.star-outline",
					variant:"light",
					order:0,
					fn:() => removeFavourite(tag._id),
				});
			}
			else {
				options.push({
					name:"Add to Favourites",
					icon:"mdi.star",
					variant:"light",
					order:0,
					fn:() => addFavourite(tag._id, "tag"),
				});
			}

			options.push({
				name:"Rename",
				icon:"mdi.pencil",
				variant:"light",
				order:1,
				fn:() => rename(tag),
			});

			options.push({
				name:"Set Color",
				icon:"mdi.format-color-fill",
				variant:"light",
				order:1,
				fn:() => setColor(tag),
			});

			options.push({
				name:"Delete",
				icon:"mdi.trash-can",
				order:2,
				fn:() => delTag(tag),
			});
			AppModal.context(event, options);
		};

		return {
			tags:sortedTags,
			getTagRoute,
			openContext,
			onAddTag,
		};
	}
});

